// TODO: Pull to component library
import React from "react";
import styled from "styled-components";
import { ArrowPointDownRight, spacing } from "@conserveit/blocks";

// Field indent with icon component
const Container = styled.div`
  display: flex;
  /*
  controls have an inherent property of max width 400px, the indent should
  implement this as well to constrain the icon + control
  */
  max-width: 400px;
`;

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  margin-right: ${spacing.snug};
`;

const Content = styled.div`
  width: 100%;
`;
interface Props {
  children: JSX.Element;
}

export const ChildField: React.FC<Props> = ({ children }) => (
  <Container>
    <IconContainer>
      <ArrowPointDownRight />
    </IconContainer>
    <Content>{children}</Content>
  </Container>
);
